import { WebAudioNode } from "./node.js";

class NodePanner3D extends WebAudioNode {
  namespace = "webaudio:node:panner_3d";
}

const nodePanner3D = new NodePanner3D();
export { nodePanner3D, NodePanner3D };
